var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:({
    height: _vm.height + 'px',
  }),attrs:{"src":require("@/assets/images/marca-escola-da-serra.png"),"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }